export default __webpack_public_path__ + "static/media/BirlaTisyaPS.59bb78bb.webp";